import API from '../../../../../helpers/request/api';

const api = () => new API();

const load = (postId) => {
  const query = {
    query: `{
      note(id: ${postId}) {
        id
        content
        post {
          id
        }
      }
    }`,
  };

  return api().get(query);
};

const save = (note) => {
  const query = {
    variables: { content: note.content },
    query: `mutation postNote($content: String!) {
      postNote(input: {
        content: $content,
        post_id: ${note.postId}
      })
      {
        note {
          id
          content
          post {
            id
          }
        }
      }
    }`,
  };

  return api().get(query);
};

export default {
  load,
  save,
};




// WEBPACK FOOTER //
// ./src/screens/Class/Details/Notes/queries/notes.js